import { useState } from "react"
import { Button, Form, Modal } from 'react-bootstrap'
import toast from "react-hot-toast"

import LoadingTextSwap from "../../../components/LoadingTextSwap"
import { useChangeClubTeamMemberMutation } from "../../../app/adminApiSlice"
import getPosition from "../../../utils/getPosition"

const POSSIBLE_POSITIONS = ['secretary', 'headCoach', 'welfareOfficer', 'dbsVerifier']

const AddPosition = ({ clubId, userId, currentPositions = [], children }) => {
  const [changeClubTeamMember, { isLoading }] = useChangeClubTeamMemberMutation()

  const [show, setShow] = useState(false)
  const [selectedPosition, setSelectedPosition] = useState("")
  const [error, setError] = useState("")

  // Filter out positions the user already has
  const availablePositions = POSSIBLE_POSITIONS.filter(pos => !currentPositions.includes(pos))

  const handleShow = () => setShow(true)
  const handleClose = () => {
    setShow(false)
    setSelectedPosition("")
    setError("")
  }

  const handleChange = (e) => {
    setSelectedPosition(e.target.value)
    setError("")
  }

  const handleSubmit = async () => {
    if (error) return

    try {
      if (!selectedPosition) return setError("Please select a position")

      await changeClubTeamMember({ clubId, userId, position: selectedPosition }).unwrap()

      handleClose()
      toast.success(`Position added`)

    } catch (error) {
      console.log(error)

      if (error.status === "functions/failed-precondition") {
        setError(error.data.message)
        return
      }
      toast.error("Error updating database")
      handleClose()
    }
  }

  return (
    <>
      <div onClick={handleShow}>{children}</div>

      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header className="border-0 p-0 mb-3">
          <Modal.Title className="fs-5 fw-bold">Add Position</Modal.Title>
        </Modal.Header>

        <Modal.Body className="mb-3 p-0">
          <p className="p-0 text-muted fs-7 mb-3">Please select a position to add</p>
          <Form onSubmit={e => { e.preventDefault(), handleSubmit() }}>
            <Form.Group className="mb-3">
              <Form.Select
                value={selectedPosition}
                onChange={handleChange}
                isInvalid={error}
                autoFocus
              >
                <option value="">Select a position...</option>
                {availablePositions.map(pos => (
                  <option key={pos} value={pos}>
                    {getPosition(pos)}
                  </option>
                ))}
              </Form.Select>
              <Form.Control.Feedback type="invalid" className="fw-semibold">
                <i>{error}</i>
              </Form.Control.Feedback>
            </Form.Group>
          </Form>
        </Modal.Body>

        <Modal.Footer className="p-0 border-0">
          <Button disabled={isLoading} className="shadow-sm rounded-3 m-0 fs-7 me-2" variant="dark" onClick={handleSubmit}>
            <LoadingTextSwap isLoading={isLoading}>
              Add
            </LoadingTextSwap>
          </Button>
          <Button disabled={isLoading} className="shadow-btn rounded-3 border-1 m-0 border-light fs-7" variant="" onClick={handleClose}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default AddPosition
